import type { AvailableSpotsFiltersState } from '../components/available-spots-filters-form';
import { createDefaultAvailableSpotsPeriod } from './available-spots-period-presets';

export function createDefaultFilters(): AvailableSpotsFiltersState {
  const period = createDefaultAvailableSpotsPeriod();
  return {
    ...period,
    filterBorrow: true,
    filterRent: true,
  };
}

export function hasActiveFilters(
  filters: AvailableSpotsFiltersState,
  baseline: AvailableSpotsFiltersState,
): boolean {
  return countActiveFilters(filters, baseline) > 0;
}

export function countActiveFilters(
  filters: AvailableSpotsFiltersState,
  baseline: AvailableSpotsFiltersState,
): number {
  let count = 0;
  if (
    filters.startDate !== baseline.startDate ||
    filters.endDate !== baseline.endDate
  ) {
    count += 1;
  }
  if (filters.filterBorrow !== baseline.filterBorrow) count += 1;
  if (filters.filterRent !== baseline.filterRent) count += 1;
  return count;
}
